export type UserRole = 'admin' | 'director' | 'investigador' | 'gestor' | 'consulta';

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  department?: string;
  phone?: string;
  avatar?: string;
  status: 'active' | 'inactive';
  lastLogin?: string;
  createdAt: string;
}

export interface Role {
  id: UserRole;
  name: string;
  description: string;
  permissions: string[];
  color: string;
}

export const mockRoles: Role[] = [
  {
    id: 'admin',
    name: 'Administrador',
    description: 'Acceso completo al sistema con permisos de configuración',
    permissions: [
      'Gestión de usuarios',
      'Gestión de roles',
      'Configuración del sistema',
      'Acceso a todos los módulos',
      'Exportar datos',
      'Eliminar registros'
    ],
    color: 'red'
  },
  {
    id: 'director',
    name: 'Director OTRI',
    description: 'Gestión completa de proyectos, IP y contratos',
    permissions: [
      'Gestión de proyectos',
      'Gestión de PI',
      'Gestión de contratos',
      'Gestión de stakeholders',
      'Visualización de reportes',
      'Aprobación de documentos'
    ],
    color: 'purple'
  },
  {
    id: 'investigador',
    name: 'Investigador',
    description: 'Gestión de sus propios proyectos y PI',
    permissions: [
      'Ver proyectos asignados',
      'Crear proyectos',
      'Editar proyectos propios',
      'Registrar PI',
      'Ver contratos relacionados'
    ],
    color: 'blue'
  },
  {
    id: 'gestor',
    name: 'Gestor',
    description: 'Gestión administrativa de proyectos y contratos',
    permissions: [
      'Gestión de proyectos',
      'Gestión de contratos',
      'Gestión de stakeholders',
      'Visualización de reportes',
      'Editar documentos'
    ],
    color: 'green'
  },
  {
    id: 'consulta',
    name: 'Solo Consulta',
    description: 'Acceso de solo lectura a la información',
    permissions: [
      'Ver proyectos',
      'Ver PI',
      'Ver contratos',
      'Ver stakeholders',
      'Exportar reportes básicos'
    ],
    color: 'gray'
  }
];

export const mockUsers: User[] = [
  {
    id: '1',
    name: 'Ana García',
    email: 'ana.garcia@universidad.edu',
    role: 'admin',
    department: 'OTRI',
    phone: '+34 912 345 678',
    status: 'active',
    lastLogin: '2024-01-15T10:30:00',
    createdAt: '2023-01-10T00:00:00'
  },
  {
    id: '2',
    name: 'Carlos Rodríguez',
    email: 'carlos.rodriguez@universidad.edu',
    role: 'director',
    department: 'OTRI',
    phone: '+34 912 345 679',
    status: 'active',
    lastLogin: '2024-01-15T09:15:00',
    createdAt: '2023-02-15T00:00:00'
  },
  {
    id: '3',
    name: 'María López',
    email: 'maria.lopez@universidad.edu',
    role: 'investigador',
    department: 'Ingeniería',
    phone: '+34 912 345 680',
    status: 'active',
    lastLogin: '2024-01-14T16:45:00',
    createdAt: '2023-03-20T00:00:00'
  },
  {
    id: '4',
    name: 'Juan Martínez',
    email: 'juan.martinez@universidad.edu',
    role: 'investigador',
    department: 'Ciencias',
    phone: '+34 912 345 681',
    status: 'active',
    lastLogin: '2024-01-15T08:20:00',
    createdAt: '2023-04-05T00:00:00'
  },
  {
    id: '5',
    name: 'Laura Sánchez',
    email: 'laura.sanchez@universidad.edu',
    role: 'gestor',
    department: 'OTRI',
    phone: '+34 912 345 682',
    status: 'active',
    lastLogin: '2024-01-15T11:00:00',
    createdAt: '2023-05-12T00:00:00'
  },
  {
    id: '6',
    name: 'Pedro Fernández',
    email: 'pedro.fernandez@universidad.edu',
    role: 'investigador',
    department: 'Medicina',
    status: 'active',
    lastLogin: '2024-01-13T14:30:00',
    createdAt: '2023-06-18T00:00:00'
  },
  {
    id: '7',
    name: 'Isabel Torres',
    email: 'isabel.torres@universidad.edu',
    role: 'consulta',
    department: 'Administración',
    phone: '+34 912 345 683',
    status: 'active',
    lastLogin: '2024-01-15T07:45:00',
    createdAt: '2023-07-22T00:00:00'
  },
  {
    id: '8',
    name: 'Miguel Ruiz',
    email: 'miguel.ruiz@universidad.edu',
    role: 'gestor',
    department: 'OTRI',
    status: 'inactive',
    lastLogin: '2023-12-20T10:00:00',
    createdAt: '2023-08-30T00:00:00'
  }
];
